import './FeedbackList.less';

export const prefix = 'bm-c-feedback-list';

export { default } from './FeedbackList';
